/* eslint-disable */
// https://www.npmjs.com/package/vuex-rest-api
// https://www.npmjs.com/package/vuex-rest-api#-path-required

// Main
import vuex from "vuex"
import vue from "vue"
import vapi from "vuex-rest-api"
vue.use(vuex);

// Store
const periodo = new vapi({
    baseURL: `${process.env.VUE_APP_REST}/api/periodo`,        
    state: {
        periodos: []
    }
})
.get({
    action: "aperiodicidad",
    path: function (obj) {        
        return `/activo/${obj.periodicidad}`;
    }
    ,
    beforeRequest: (state, { params, data }) => {
        
    },
    onSuccess: (state, payload, axios, { params, data }) => {
                state.periodos = payload.data;
    }
}).getStore();

periodo.getters = {
    gperiodos: state => {
        return state.periodos;
    }
}

export default periodo;
